module.exports = __webpack_public_path__ + "static/media/Александрова Е.А. Шамматова А.А., Башмаков Р.А..4073fc25.pdf";